import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	monitorOne: 3,
	monitorTwo: 4,
	monitorThree: 5,
	monitorFour: 6,
	win: 7,
}

export const Tema5SubtopicTwoActivityTwo = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema5.activities.subtema2], 2);
	useEffect(() => {
		if (loaded) {
			console.log("tema 5 subtema2 activity 2");
			ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub02.sub2_act2_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.initScene, 2);
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's2_m1')
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, true)
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.05, 2.92)
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 2: Simulación de retiro efectivo." />
					<DialogBarNew
						dialog={
							'El Retiro de Efectivo se realizaría de esta manera.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Retiro de efectivo"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's2_m1')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, true)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.05, 2.92)
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor)
							setUiToShow(steps.monitorOne);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub02.sub2_act2_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.monitorOne && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						dialog={
							'Primer paso: Presiona la tecla "F8" para que aparezca la ventana de ingreso de contraseña.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub02.sub2_act2_a03)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, false)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's2_m2')
							setUiToShow(steps.monitorTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorTwo && (
				<>
					<DialogBarNew
						dialog={
							'Segundo paso: Al dar clic en "Aceptar" aparece la pantalla para ingresar el monto a retirar.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub02.sub2_act2_a04)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's2_m3')
							setUiToShow(steps.monitorThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorThree && (
				<>
					<DialogBarNew
						dialog={
							'Tercer paso: Escribe "P" si el tipo de moneda a retirar son pesos mexicanos, o "D" si son dólares, y por último escribe el monto a retirar.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub02.sub2_act2_a05)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's2_m4')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, true)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.039, 2.69)
							setUiToShow(steps.monitorFour);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorFour && (
				<>
					<DialogBarNew
						dialog={
							'Cuarto paso: Al dar "Enter" se muestra la ventana de confirmación. Selecciona "Sí", si es el monto correcto.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, false)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="¡Excelente! Ahora ya sabes los pasos para el retiro de efectivo."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 10,
									subtema: tasksId.tema5.activities.subtema2,
								})
							);
							navigation("/home5/tema5/subtema2/results");
						}}
					/>
				</>
			)}

		</>

	)
}